export default "__VITE_ASSET__BhNIk1VO__"